import 'bootstrap/dist/css/bootstrap.min.css';
import * as bootstrap from 'bootstrap';

// Importar estilos personalizados
import './styles/main.css';
import './styles/schedule-styles.css';

// Make bootstrap global
(window as any).bootstrap = bootstrap;

// Import Riot
import * as riot from 'riot';

// Import root component
import App from './components/app.riot';

// Mount the root component
document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById('root');
  if (root) {
    riot.component(App)(root, {});
  }
});
